/**
 * Rewrite hardcoded dev/stage/prod marketing URLs in article HTML to match
 * the current blog host environment (same maps as nav/footer chrome).
 */

const CLIQLOAN_ORIGINS = [
  'https://qa.dev.cliqloan.com',
  'https://qa.stage.cliqloan.com',
  'https://www.cliqloan.com',
  'http://qa.dev.cliqloan.com',
  'http://qa.stage.cliqloan.com',
];

const AMITASOFT_ORIGINS = [
  'https://qa.dev.amitasoft.com',
  'https://qa.stage.amitasoft.com',
  'https://www.amitasoft.com',
  'http://qa.dev.amitasoft.com',
  'http://qa.stage.amitasoft.com',
];

const SAFEVAULTUSA_ORIGINS = [
  'https://qa.dev.safevaultusa.com',
  'https://qa.stage.safevaultusa.com',
  'https://www.safevaultusa.com',
  'http://qa.dev.safevaultusa.com',
  'http://qa.stage.safevaultusa.com',
];

const SAFEVAULT_ORIGINS = [
  'https://qa.dev.safevault.com',
  'https://qa.stage.safevault.com',
  'https://www.safevault.com',
];

const KRAMASOFT_APP_ORIGINS = [
  'https://dev.kramasoft.com',
  'http://dev.kramasoft.com',
];

const CLIQLOAN_APP_ORIGINS = [
  'https://stage.cliqloan.com',
  'https://app.cliqloan.com',
];

const BLOG_ORIGINS = [
  'https://dev.kramasoft.com/blog',
  'https://stage.cliqloan.com/blog',
  'https://www.cliqloan.com/blog',
  'https://qa.dev.cliqloan.com/blog',
  'https://qa.stage.cliqloan.com/blog',
  'https://qa.dev.amitasoft.com/blog',
  'https://qa.stage.amitasoft.com/blog',
  'https://www.amitasoft.com/blog',
  'https://qa.dev.safevaultusa.com/blog',
  'https://qa.stage.safevaultusa.com/blog',
  'https://www.safevaultusa.com/blog',
];

const SAFEVAULT_APP_ORIGINS = [
  'https://app.safevaultusa.com',
  'https://stage.safevaultusa.com',
  'https://dev.safevault.kramasoft.com',
];

function stripTrailingSlash(value) {
  return String(value || '').replace(/\/$/, '');
}

function joinBaseAndPath(base, path) {
  const normalizedBase = stripTrailingSlash(base);
  if (!path || path === '/') {
    return normalizedBase;
  }
  return `${normalizedBase}${path.startsWith('/') ? path : `/${path}`}`;
}

function replaceOrigin(url, origins, targetBase) {
  for (const origin of origins) {
    if (url.startsWith(origin)) {
      const path = url.slice(origin.length) || '/';
      return joinBaseAndPath(targetBase, path);
    }
  }
  return null;
}

function rewriteAppUrl(url, siteUrls) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  const path = `${parsed.pathname}${parsed.search}${parsed.hash}`;

  if (KRAMASOFT_APP_ORIGINS.some((origin) => url.startsWith(origin))) {
    if (path.startsWith('/signin')) return siteUrls.signIn;
    if (path.startsWith('/signup')) return siteUrls.signUp;
    if (path.includes('/contact-us')) return siteUrls.apiContactUs;
    if (path.includes('/demo-schedule')) return siteUrls.apiScheduleDemo;
  }

  if (CLIQLOAN_APP_ORIGINS.some((origin) => url.startsWith(origin))) {
    if (path.startsWith('/signin')) return siteUrls.signIn;
    if (path.startsWith('/signup')) return siteUrls.signUp;
    if (path.includes('/contact-us')) return siteUrls.apiContactUs;
    if (path.includes('/demo-schedule')) return siteUrls.apiScheduleDemo;
  }

  if (SAFEVAULT_APP_ORIGINS.some((origin) => url.startsWith(origin))) {
    if (path.startsWith('/login')) return siteUrls.login;
    if (path.startsWith('/register') || path.startsWith('/signup')) return siteUrls.getStarted || siteUrls.signUp;
  }

  return null;
}

function resolveTargetBase(siteUrls, brand) {
  switch (brand) {
    case 'cliqloan':
      return siteUrls.cliqloanHome || siteUrls.marketingHome;
    case 'amitasoft':
      return siteUrls.amitasoftHome || siteUrls.marketingHome;
    case 'safevault':
      return siteUrls.safevaultHome || siteUrls.marketingHome;
    default:
      return null;
  }
}

function rewriteMarketingUrl(url, siteUrls) {
  const cliqloanBase = resolveTargetBase(siteUrls, 'cliqloan');
  const amitasoftBase = resolveTargetBase(siteUrls, 'amitasoft');
  const safevaultBase = resolveTargetBase(siteUrls, 'safevault');

  return (
    replaceOrigin(url, CLIQLOAN_ORIGINS, cliqloanBase)
    || replaceOrigin(url, AMITASOFT_ORIGINS, amitasoftBase)
    || replaceOrigin(url, SAFEVAULTUSA_ORIGINS, safevaultBase)
    || replaceOrigin(url, SAFEVAULT_ORIGINS, safevaultBase)
    || rewriteAppUrl(url, siteUrls)
    || (siteUrls.blogPublicUrl
      ? replaceOrigin(url, BLOG_ORIGINS, stripTrailingSlash(siteUrls.blogPublicUrl))
      : null)
  );
}

export function rewriteArticleLinks(html, siteUrls) {
  if (!html || !siteUrls) {
    return html || '';
  }

  return html.replace(/href="(https?:\/\/[^"#?\s]+(?:\/[^"]*)?)"/gi, (match, url) => {
    const rewritten = rewriteMarketingUrl(url, siteUrls);
    return rewritten ? `href="${rewritten}"` : match;
  });
}

export default rewriteArticleLinks;
